// # axios
// # https://blog.csdn.net/qq_61950936/article/details/126396941
// # https://www.axios-http.cn/docs/interceptors
import axios from 'axios'
import md5 from 'js-md5';
import initRequestNoticeMessageata from './noticeMessage'

export default (app) => {
    
    // # MD5
    app.config.globalProperties.$md5 = md5

    // # 全局变量访问 this.$http.*
    app.config.globalProperties.$http = axios

    // # 请求拦截器
    axios.interceptors.request.use(config => {

        // # 开发模式地址查看 @see vue.config.js
        // # 正式发布请配置适应
        config.url = 'api/' + config.url

        // # 返回重置好的配置
        return config;
    })

    // # 定义一个全局 Post json header
    app.config.globalProperties.$httpJson = (url, data)=> {
        return axios({
            method: 'post',
            headers: {'contentType': 'application/json;charset=utf-8'},
            url: url, 
            data: data
        })
    }

    let refreshFunc = null;
    app.config.globalProperties.$setRefresh = (func) => {
        refreshFunc = func
    }

    // # 
    app.config.globalProperties.$refresh = () => {
        if(refreshFunc) {
            refreshFunc()
        }
    }

    // # 初始化获取消息
    initRequestNoticeMessageata()
}